// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file responses/v1/ecom_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/ecom_response.proto.
 */
export const file_responses_v1_ecom_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CiByZXNwb25zZXMvdjEvZWNvbV9yZXNwb25zZS5wcm90bxIMcmVzcG9uc2VzLnYxIroCCgxFY29tUmVzcG9uc2USCgoCaWQYASABKAQSDgoGZG9tYWluGAIgASgJEhEKCXVuaXF1ZV9pZBgDIAEoCRJPChZtYXJrZXRfZHJpdmVuX3NoaXBwaW5nGAQgASgOMi8ucmVzcG9uc2VzLnYxLkVjb21SZXNwb25zZS5NYXJrZXREcml2ZW5TaGlwcGluZyKpAQoUTWFya2V0RHJpdmVuU2hpcHBpbmcSJgoiTUFSS0VUX0RSSVZFTl9TSElQUElOR19VTlNQRUNJRklFRBAAEiEKHU1BUktFVF9EUklWRU5fU0hJUFBJTkdfTEVHQUNZEAESIwofTUFSS0VUX0RSSVZFTl9TSElQUElOR19NSUdSQVRFRBACEiEKHU1BUktFVF9EUklWRU5fU0hJUFBJTkdfQUNUSVZFEANCfAoQY29tLnJlc3BvbnNlcy52MUIRRWNvbVJlc3BvbnNlUHJvdG9QAVoELi9wYqICA1JYWKoCDFJlc3BvbnNlcy5WMcoCDFJlc3BvbnNlc1xWMeICGFJlc3BvbnNlc1xWMVxHUEJNZXRhZGF0YeoCDVJlc3BvbnNlczo6VjFiBnByb3RvMw'
    );

/**
 * @generated from message responses.v1.EcomResponse
 */
export type EcomResponse = Message<'responses.v1.EcomResponse'> & {
    /**
     * @generated from field: uint64 id = 1;
     */
    id: bigint;

    /**
     * @generated from field: string domain = 2;
     */
    domain: string;

    /**
     * @generated from field: string unique_id = 3;
     */
    uniqueId: string;

    /**
     * @generated from field: responses.v1.EcomResponse.MarketDrivenShipping market_driven_shipping = 4;
     */
    marketDrivenShipping: EcomResponse_MarketDrivenShipping;
};

/**
 * Describes the message responses.v1.EcomResponse.
 * Use `create(EcomResponseSchema)` to create a new message.
 */
export const EcomResponseSchema: GenMessage<EcomResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_ecom_response, 0);

/**
 * @generated from enum responses.v1.EcomResponse.MarketDrivenShipping
 */
export enum EcomResponse_MarketDrivenShipping {
    /**
     * @generated from enum value: MARKET_DRIVEN_SHIPPING_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,

    /**
     * @generated from enum value: MARKET_DRIVEN_SHIPPING_LEGACY = 1;
     */
    LEGACY = 1,

    /**
     * @generated from enum value: MARKET_DRIVEN_SHIPPING_MIGRATED = 2;
     */
    MIGRATED = 2,

    /**
     * @generated from enum value: MARKET_DRIVEN_SHIPPING_ACTIVE = 3;
     */
    ACTIVE = 3,
}

/**
 * Describes the enum responses.v1.EcomResponse.MarketDrivenShipping.
 */
export const EcomResponse_MarketDrivenShippingSchema: GenEnum<EcomResponse_MarketDrivenShipping> =
    /*@__PURE__*/
    enumDesc(file_responses_v1_ecom_response, 0, 0);
